export default "__VITE_ASSET__e7c52999__"